var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM10.49 16.72C10.15 17.06 9.7 17.29 9.15 17.36L7.8 17.51C7.06 17.59 6.43 16.96 6.51 16.21L6.66 14.85C6.79 13.64 7.8 12.87 8.87 12.85C8.97 12.84 9.09 12.85 9.2 12.86C9.67 12.92 10.12 13.14 10.5 13.51C10.87 13.88 11.08 14.32 11.14 14.77C11.15 14.88 11.16 14.99 11.16 15.09C11.16 15.71 10.93 16.28 10.49 16.72ZM17.44 7.55C16.72 9.35 15.07 11.71 13.5 13.25C13.27 11.83 12.14 10.71 10.7 10.51C12.24 8.93 14.62 7.26 16.43 6.53C16.75 6.41 17.07 6.5 17.27 6.7C17.47 6.92 17.57 7.23 17.44 7.55Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicpen);
export default __webpack_public_path__ + "static/media/magicpen.76f65f828e48580db6bf4c804a894272.svg";
export { ForwardRef as ReactComponent };